<main>
    <div class="d-flex flex-row justify-content-center admin-page-header">
        <h1 class="admin-page-title">
            Video Guides
        </h1>
    </div>


    <div class="mediumContainer">
        @if (loading || !loading && trainingCentre.length == 0) {
            <div aria-live="polite" class="w-100 d-flex flex-col align-items-center" role="status">
                @if (loading) {
                    <mat-spinner aria-label="Loading video guides" color="primary"></mat-spinner>
                }
                @if (!loading && trainingCentre.length == 0) {
                    <div class="illustrated-empty-state">
                        <img src="assets/images/reading-character.png" width="431" height="422"
                             alt="Yellow character reading a book">
                        @if (loadFailed) {
                            <h2>We couldn't load the video guides</h2>
                            <p>Please refresh the page to try again.</p>
                        } @else {
                            <h2>Nothing here just yet</h2>
                            <p>No video guides are available for your account right now. Please check back later.</p>
                        }
                    </div>
                }
            </div>
        }
        <div class="memoriesContainer">
            @for (resource of trainingCentre; track resource; let i = $index) {
                <mat-card class="spaceContent">
                    <mat-card-header>
                        <mat-card-title class="mb-0">{{ getIndex(resource) }}. {{ resource.title }}</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <video (play)="recordVideoView(resource)" class="videoControl" controls crossorigin="anonymous">
                            <source [src]="resource.attachment">
                            @if (resource.vtt_file) {
                                <track
                                        [src]="resource.vtt_file"
                                        default
                                        kind="captions"
                                        label="English"
                                        srclang="en"/>
                            }
                            Your browser does not support the video tag.
                        </video>
                        <p>
                            {{ resource.description }}
                        </p>
                    </mat-card-content>
                    <mat-card-actions class="d-flex flex-row flex-space-around">
                        <button (click)="openGuide(resource)" color="primary" mat-raised-button>
                            Play
                        </button>
                    </mat-card-actions>
                </mat-card>
            }
        </div>
    </div>
</main>
